import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="guide" className="scroll-mt-24 bg-[#faf5ee]">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1">
            <div className="text-xs font-semibold tracking-widest text-[#c2410c] mb-2 flex items-center gap-2">
              <i className="ri-question-answer-line"></i> GUIDE
            </div>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-[#241c15] leading-tight">
              吃瓜指南 · 常见问题
            </h2>
            <p className="text-sm leading-6 text-[#7a6a58] mt-4">
              关于信息可靠性、辟谣机制、投稿方式与订阅更新，这里给出了编辑部最常被问到的问题。
            </p>
            <a
              href="#about"
              className="inline-flex items-center gap-2 text-sm font-semibold text-[#c2410c] mt-5 hover:underline cursor-pointer"
            >
              还有问题？联系我们
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:col-span-2">
            <div className="space-y-3">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={i}
                    className={`bg-white border rounded-xl overflow-hidden transition-colors ${
                      isOpen ? "border-[#c2410c]/40" : "border-[#ead9c5] hover:border-[#c9a576]"
                    }`}
                  >
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="w-full flex items-start gap-3 text-left px-5 py-4 cursor-pointer"
                    >
                      <span
                        className={`mt-0.5 w-6 h-6 shrink-0 flex items-center justify-center rounded-md text-xs font-bold ${
                          isOpen ? "bg-[#c2410c] text-white" : "bg-[#fde8d7] text-[#c2410c]"
                        }`}
                      >
                        {i + 1}
                      </span>
                      <span className="flex-1">
                        <h3 className="text-[15px] font-semibold text-[#241c15] leading-snug">
                          {f.q}
                        </h3>
                        {isOpen && (
                          <p className="text-[14px] leading-7 text-[#6b5d4d] mt-3 pr-2">{f.a}</p>
                        )}
                      </span>
                      <i
                        className={`ri-add-line text-[#c2410c] mt-1 transition-transform ${
                          isOpen ? "rotate-45" : ""
                        }`}
                      ></i>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}